<!--问题反馈-->
<template>
  <div class="feedback-container">
    <cv-navbar/>
    <div class="input-box-container">
      <p v-if="isForbiddenApply" class="tips">申诉只可以提交1次，请详细填写您的申诉内容，反馈时间在7个工作日以内</p>
      <el-form ref="form" :model="formData" :rules="rules" label-width="0">
        <el-form-item label="" prop="user_email">
          <el-input v-model="formData.user_email" placeholder="请输入您的邮箱" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item v-if="isForbiddenApply" label="" prop="user_phone">
          <el-input v-model="formData.user_phone" placeholder="请输入您的手机号" style="width: 100%" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item v-if="!isForbiddenApply" label="" prop="feedback_type">
          <el-select v-model="formData.feedback_type" placeholder="请选择问题类型" style="width: 100%">
            <el-option
                    v-for="item in feedbackOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="content">
          <el-input
                  type="textarea"
                  :rows="2"
                  :placeholder="isForbiddenApply ? '请填写您的申诉内容' : '请描述您的具体问题或建议'"
                  resize="none"
                  v-model="formData.content" style="width: 100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <div class="img-desc">添加图片说明（{{formData.images.length}}/4张）</div>
          <input type="file" class="img-file" id="img-file" ref="imgFile" @change="readImg">
          <div class="img-container">
            <div class="img" v-for="item in formData.images">
              <img :src="item" alt="">
              <div class="remove-img" @click="removeImg(item)">×</div>
            </div>
            <div class="upload-btn" @click="uploadImg" :style="{'marginLeft' : formData.images.length > 0 ? '20px' : '0px'}" v-show="formData.images.length < 4"></div>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="submit-btn" @click="submitFeedback">提交</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import cvNavbar from '@/components/base/navbar';
  const oss = require('ali-oss')
  import {uuid} from 'vue-uuid'
  import {dataURLtoBlob, blobToFile, get_tUser, routerTo} from '../../assets/js/util'
  import api from '@/api'

  export default {
    name: "feedback",
    components:{
      cvNavbar
    },
    data() {
      
      return {
        formData: {
          feedback_platform: 'pc_vue',
          user_email: '',
          user_phone: '',
          feedback_type: '',
          content: '',
          images: [],
          token: get_tUser().c_t
        },
        feedbackOption: [
          { value:0,label:'BUG反馈' },
          { value:1,label:'简历功能' },
          { value:2,label:'求职信/邮件功能' },
          { value:3,label:'会员功能' },
          { value:4,label:'导师辅导' },
          { value:5,label:'其他功能' }
        ],
        // feedbackOption: [ "BUG反馈", "简历功能","求职信/邮件功能", "会员功能", "导师辅导","其他功能" ],
        // rules:{
        //   content: [
        //     { required: true, message: '请输入详细的问题描述', trigger: 'blur' }
        //   ],
        //   user_email: [
        //     { validator: checkEmail, trigger: 'blur' }
        //   ],
        //   user_phone: [
        //     { required: true, message: '请输入手机号', trigger: 'blur' }
        //   ],
        //   feedback_type: [
        //     { required: true, message: '请选择问题类型', trigger: 'change' }
        //   ],
        //   images: [
        //     { type: 'array', required: true, message: '请上传详细图片说明', trigger: 'change' }
        //   ]
        // },
        ossConfig: {}, // oss的配置
      }
    },
    mounted() {
      this.getOssConfig()
    },
    methods: {
      // 上传图片到阿里云
      async uploadOss(baseImg) {
        let store = await oss(this.ossConfig)
        let avatar = `${uuid.v1()}-avatar`;
        let blob = dataURLtoBlob(baseImg)
        let fileData = blobToFile(blob, avatar)
        try {
          let res = await store.put(`cv/profile/avatars/${avatar}`, fileData)
          if (res.res.statusCode !== 200) {
            this.$createToast({
              txt: '上传失败',
              time: 1000,
              type: 'warn'
            }).show()
            return
          }
          // let {url} = process.env.VUE_APP_ENV === 'local'?res.replace(/http:/g,'https:'):res;
          let {url} = res;
          this.formData.images.push(url)
          this.$refs.imgFile.value = '';
        } catch (e) {
          console.log(e)
        }
      },
      // 删除图片
      removeImg(obj) {
        this.formData.images.splice(this.formData.images.indexOf(obj),1)
      },
      // 模拟点击
      uploadImg() {
        if (this.formData.images.length >= 4) {
          this.$message.error('最多上传4张图片')
          return
        }else {
          this.$refs.imgFile.click()
        }
      },
      // 上传图片
      readImg() {
        var file =this.$refs.imgFile.files;
        if (file) {
          const reader = new FileReader()
          if (file[0].type !== 'image/png' && file[0].type !== 'image/gif' && file[0].type !== 'image/jpeg') {
            this.$message.error('请选择正确的图片格式')
            return
          }
          reader.readAsDataURL(file[0])
          reader.onload = e => {
            let url = reader.result;
            // this.formData.images.push(url);
            this.uploadOss(url)

          }
        }
      },
      // 提交数据
      submitFeedback() {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.formData.feedback_type = this.isForbiddenApply ? 9 : this.formData.feedback_type
            let res = await api.account.feedbackSubmit(this.formData)
            if (res.code === 1000) {
              this.$message.success(res.message)
              setTimeout(()=>{
                routerTo('/cvs')
              },1500)
            }else {
              this.$message.error(res.message)
            }
            // console.log(res,"======>问题反馈res")
          } else {
            this.$message.error('请检查您填写的问题反馈是否符合输入规则')
            return false;
          }
        });
      },
      // 初始化oss参数
      async getOssConfig() {
        let res = await api.account.getOssConfig({
          marking:'feedback'
        })
        if (res.code === 1000) {
          let {access_key_id, access_key_secret, expiration, request_id, security_token, bucket_name} = res.data
          this.ossConfig = {
            region: 'oss-cn-beijing',
            accessKeyId: access_key_id,
            accessKeySecret: access_key_secret,
            bucket: bucket_name,
            stsToken: security_token,
            secure:true
          }
        } else {
          this.$message.error('请求出错啦，请检查网络')
        }
      },
      checkEmail(rule, value, callback) {
        if (value === '') {
          callback(new Error('请输入您的联系邮箱'));
        } else {
          let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9-])+((\.[a-zA-Z0-9-]{2,3}){1,2})$/gim;
          if (!reg.test(this.formData.user_email)) {
            callback(new Error('请输入正确的邮箱格式'));
          }else {
            callback();
          }
        }
      }
    },
    computed: {
      isForbiddenApply() {
        return this.$route.query.type === '9'
      },
      rules() {
        const rules = {
          content: [
            { required: true, message: '请输入详细的问题描述', trigger: 'blur' }
          ],
          user_email: [
            { validator: this.checkEmail, trigger: 'blur' }
          ],
          images: [
            { type: 'array', required: true, message: '请上传详细图片说明', trigger: 'change' }
          ]
        }

        if (this.isForbiddenApply) {
          return {
            ...rules,
            user_phone: [
              { required: true, message: '请输入正确手机号', trigger: 'blur' },
              { min: 11, max: 11, message: '请输入正确手机号', trigger: 'blur' }
            ],
          }
        } else {
          return {
            ...rules,
            feedback_type: [
              { required: true, message: '请选择问题类型', trigger: 'change' }
            ],
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-input .el-input__inner{
    border-color: #d8d8d8!important;
  }
  /deep/ .el-form-item.is-error .el-textarea__inner,/deep/ .el-form-item.is-error .el-input__inner{
    border-color: #f56c6c!important;
  }
  .feedback-container{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding-top: 56px;
    display: flex;
    justify-content: center;
    .input-box-container{
      width: 758px;
      height: 595px;
      background-color: #fff;
      margin-top: 24px;
      box-sizing: border-box;
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      padding: 32px 46px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .tips {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
        color: #404040;
      }
      .el-form{
        width: 100%;
        .el-form-item{
          margin-bottom: 24px;
          &:last-child{
            margin-top: 72px;
          }
          /deep/ .el-input__inner{
            height: 46px;
          }
          /deep/ .el-textarea__inner{
            height: 113px;
          }
          .img-file{
            display: none;
          }
          .img-desc{
            color: #404040;
          }
          .img-container{
            display: flex;
            .img{
              width: 84px;
              height: 84px;
              margin-left: 20px;
              border-radius: 3px;
              overflow: hidden;
              position: relative;
              img{
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              .remove-img{
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                background-color: rgba(0,0,0,.6);
                color: #fff;
                border-radius: 50%;
                cursor: pointer;
                position: absolute;
                top: 5px;
                right: 5px;
              }
              &:first-child{
                margin-left: 0;
              }
            }
            .upload-btn{
              width: 84px;
              height: 84px;
              background: url("../../assets/image/uoload-btn.png") no-repeat;
              background-size: 100% 100%;
              cursor: pointer;
            }
          }
          .submit-btn{
            width: 190px;
            height: 48px;
            background-color: #ff4f4c;
            border-radius: 3px;
            color: #fff;
            font-size: 16px;
            text-align: center;
            line-height: 48px;
            margin: 0 auto;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>